import { Container } from './styled';

export function Info(props) {

    const { message } = props;

    return (
        <Container>
            <div className='line'/>
            <div className='msg--'>
                {message.body}
            </div>
            <div className='line'/>
        </Container>
    )
}